import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────

const caseyKeyConfig = {
  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Casey Key Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree removal and trimming in Casey Key, FL. Sam\'s Tree Service tackles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_casey_key',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Casey Key',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Casey Key Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we take on the toughest tree jobs on 
     <strong>Casey Key</strong>. The narrow barrier island setting means trees grow close to 
     structures, driveways, and the water's edge and when storms roll through, those trees 
     become serious hazards fast. Our team has the experience and equipment to handle precision 
     trimming, targeted removal, and emergency cleanup when you need it most.`,

    `We specialize in <strong>hazardous and storm damaged trees</strong> weakened root systems 
     from sandy soil, wind twisted canopies, leaning trunks threatening seawalls or homes, and 
     overgrowth pressing against structures. No job is too tight or too technical for our crew.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, expert tree care across 
     <strong>Casey Key</strong> and the surrounding <strong>Southwest Florida</strong> coastline, 
     so your property stays protected no matter what the season brings.`,
  ],
  

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Casey Key, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_CaseyKey = () => <LocationPage config={caseyKeyConfig} />;
export default Services_CaseyKey;
